module.exports = __webpack_public_path__ + "images/star-struck-gif.gif";